import { render } from "./View.vue?vue&type=template&id=825a426e"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/View.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "825a426e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('825a426e', __exports__)) {
    api.reload('825a426e', __exports__)
  }
  
  module.hot.accept("./View.vue?vue&type=template&id=825a426e", () => {
    api.rerender('825a426e', render)
  })

}


export default __exports__